export const envYear = 2026;
export const startDate = "2026-10-26"
export const endDate = "2026-11-04"

export const apiEnv = () => {
    switch (location.host) {
      //  == DEVELOPMENT ==
      case "localhost:8080":
      case "localhost:8081":
      case "0.0.0.0:8080":
      case "0.0.0.0:8081":
      case "127.0.0.1:8080":
      case "127.0.0.1:8081":
        var apiPath = `https://stg-api-${envYear}.tiff-jp.net/api`;
        break;
      //  == STAGING ==
      case `stg-${envYear}.tiff-jp.net`:
        var apiPath = `https://stg-api-${envYear}.tiff-jp.net/api`;
        break;
      //  == PRODUCTION ==
      default:
        var apiPath = `https://api-${envYear}.tiff-jp.net/api`;
        break;
    }
    return apiPath;
}
export const ticketEnv = () => {
    switch (location.host) {
      //  == DEVELOPMENT ==
      case "localhost:8080":
      case "localhost:8081":
      case "0.0.0.0:8080":
      case "0.0.0.0:8081":
      case "127.0.0.1:8080":
      case "127.0.0.1:8081":
        var ticketPath = "https://reserve.smart-theater.com/projects/tiff2026-production/purchase/transaction/";
        break;
      //  == STAGING ==
      case `stg-${envYear}.tiff-jp.net`:
        var ticketPath = "https://reserve.smart-theater.com/projects/tiff2026-production/purchase/transaction/";
        break;
      //  == PRODUCTION ==
      default:
        var ticketPath = "https://reserve.smart-theater.com/projects/tiff2026-production/purchase/transaction/";
        break;
    }
    return ticketPath;
}



// WEBPACK FOOTER //
// ./src/env.js